import { Card, Stack } from "@mui/material";
import { AdditionalInfo } from "Components/Shared/BanksList/BankButton/Components/BankRatingDetail/AdditionalInfo";
import { Email } from "Components/Shared/BanksList/BankButton/Components/BankRatingDetail/Email";
import { Header } from "Components/Shared/BanksList/BankButton/Components/BankRatingDetail/Header";
import { HowToConnect } from "Components/Shared/BanksList/BankButton/Components/BankRatingDetail/HowToConnect";
import { NotRecommendedInfobox } from "Components/Shared/BanksList/BankButton/Components/BankRatingDetail/NotRecommendedInfobox";
import { Review } from "Components/Shared/BanksList/BankButton/Components/BankRatingDetail/Review";
import { Warning } from "Components/Shared/BanksList/BankButton/Components/BankRatingDetail/Warning";
import { useIsCurrentUserMerchant } from "Hooks/useIsCurrentUserMerchant";
import type { Bank } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  bank: Bank;
  isInModal?: boolean;
};

export const BankRatingDetail = ({ bank, isInModal }: Props) => {
  const { exists } = useResource();
  const isMerchant = useIsCurrentUserMerchant();
  const isNotRecommended =
    !isMerchant &&
    exists(Resources.BankRating.Banks[bank].NotRecommended?.Reason);

  return (
    <Card sx={{ boxShadow: "none" }}>
      <Stack gap={4}>
        <Header bank={bank} isInModal={isInModal} />
        {isNotRecommended && <NotRecommendedInfobox bank={bank} />}
        <AdditionalInfo bank={bank} />
        <Warning bank={bank} />
        <HowToConnect bank={bank} />
        <Review bank={bank} />
        <Email bank={bank} />
      </Stack>
    </Card>
  );
};
